// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"269":"ssoBuyerShop","350":"jobConfig","597":"projects","602":"notification","666":"workspace","724":"ssoBuyerCompanyGallery","965":"shoppingcart"}[chunkId] + "." + {"269":"8d7d3948","350":"8a01e60a","597":"0040a9cf","602":"49dffc28","666":"37d5e133","724":"19845fac","965":"64003762"}[chunkId] + ".chunk.css";
};